<template>
  <span>
    <v-icon
      class="mr-2"
      :color="disabled ? 'grey lighten-1' : 'primary'"
      @click.stop="dialogClicked()"
      >mdi-content-copy</v-icon
    >

    <v-dialog v-model="dialog" width="50%">
      <v-card class="rounded-lg">
        <v-card-title color="white" primary-title>
          <v-icon color="primary">mdi-content-copy</v-icon>
          <span class="primary--text text--darken-3 title pl-2"
            >Copy {{ collection.label }}</span
          >
        </v-card-title>

        <v-card-text class="pt-4">
          Create a copy of this Study Dataset. You can add or remove variables
          on the copy afterward.

          <v-text-field
            v-model="name"
            class="pt-4"
            label="Name of copied Study Dataset"
            :rules="[v => !!v || 'A name is required.']"
            required
          ></v-text-field>

          <div class="subtitle-1 font-weight-bold pt-2">Include:</div>
          <v-radio-group v-model="include" class="mt-1">
            <v-radio value="dataset">
              <template v-slot:label>
                <span>Study Dataset only</span>
              </template>
            </v-radio>
            <v-radio value="cohorts" :disabled="!hasCohorts">
              <template v-slot:label>
                <span
                  >Study Dataset and Study Groups<span
                    v-if="!hasCohorts"
                    class="grey--text font-italic"
                  >
                    (no study groups created)</span
                  ></span
                >
              </template>
            </v-radio>
            <v-radio value="analyses" :disabled="!hasAnalyses">
              <template v-slot:label>
                <span
                  >Study Dataset, Study Groups, and Analyses<span
                    v-if="!hasAnalyses"
                    class="grey--text font-italic"
                  >
                    (no analyses created)</span
                  ></span
                >
              </template>
            </v-radio>
          </v-radio-group>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialog = false">
            <v-icon left>close</v-icon> Cancel
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!name || !name.trim() || cloning"
            :loading="cloning"
            @click="copyCollection"
          >
            <v-icon left>mdi-content-copy</v-icon> Copy</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import { actions as notifyActions } from '@/store/modules/notifications/types';

export default {
  props: {
    collection: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    name: '',
    include: 'dataset',
    cloning: false,
  }),
  computed: {
    hasCohorts() {
      return (this.collection.num_cohorts || 0) > 0;
    },
    hasAnalyses() {
      return (this.collection.num_analyses || 0) > 0;
    },
  },
  watch: {
    dialog(dl) {
      if (dl) {
        this.name = `${this.collection.label} - Copy`;
        this.include = 'dataset';
      }
    },
  },
  methods: {
    ...mapActions('notifications', {
      notifyError: notifyActions.NOTIFY_ERROR,
      notifySuccess: notifyActions.NOTIFY_SUCCESS,
    }),
    dialogClicked() {
      if (this.disabled) return;
      this.dialog = !this.dialog;
    },
    copyCollection() {
      this.cloning = true;
      const url = '/api/collections/' + this.collection.id + '/copy';
      const request_data = { label: this.name.trim(), include: this.include };
      return axios
        .post(url, request_data)
        .then(({ data }) => {
          this.notifySuccess('Study Dataset successfully copied.');
          this.$emit('collectionCopied', data.collection);
          this.dialog = false;
        })
        .catch(err => {
          if (err.response) {
            this.notifyError(
              'Copy request failed with status ' +
                err.response.status +
                ', error ' +
                err.response.data.error
            );
          } else {
            this.notifyError('Copy failed, err=' + err);
          }
        })
        .finally(() => {
          this.cloning = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
